<template>
  <defaultView></defaultView>
</template>

<script>
import baseLogin from "@base/views/user/login/default.vue";
import { haierLoginRedirect } from '@/utils/haierLoginScope';

const defaultView = {
  name: 'HaierLogin',
  extends: baseLogin,
  mixins: [haierLoginRedirect]
};

export default {
  name: 'HaierLoginPage',
  components: {defaultView}
}
</script>
<style lang="scss" scoped>

</style>
